import { Controller } from "@hotwired/stimulus"
import { readRememberedState, persistRememberedState } from "../lib/remembered_state"

// Un panneau replié ou déplié par un bouton, quand la balise native ne peut pas s'en charger.
//
// Le reste du back-office replie ses encarts avec un `<details>` — voir `remembered-disclosure`,
// qui ne lui ajoute que la mémoire. Ici c'est impossible : la ligne qui commande le repli porte
// des boutons et un formulaire, or un `<summary>` n'a le droit de contenir ni l'un ni l'autre.
// Un clic sur le crayon ou la corbeille aurait en prime basculé le repli sous les doigts.
//
// Ce que le contrôleur doit donc reprendre à la balise native, et qu'elle donnait gratuitement :
// l'état annoncé aux lecteurs d'écran, porté ici par `aria-expanded` sur le bouton.
//
// `key` est facultative. Avec elle, l'état SURVIT au changement d'écran : un dossier replié le
// reste quand on revient sur la liste. Sans elle, le panneau repart de son état rendu — c'est ce
// qu'on veut d'un formulaire de renommage, qui n'a aucune raison de s'ouvrir tout seul.
export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values = { key: String }

  connect() {
    if (!this.hasKeyValue || this.keyValue === "") return

    // `null` = jamais choisi : on laisse alors l'état rendu par le serveur, qui porte le défaut
    // voulu. L'écraser par `false` replierait ce que le serveur ouvre exprès.
    const remember = readRememberedState(this.keyValue)
    if (remember !== null) this.#apply(remember)
  }

  toggle() {
    this.#apply(!this.#open)
    if (this.hasKeyValue && this.keyValue !== "") persistRememberedState(this.keyValue, this.#open)
  }

  get #open() {
    return this.triggerTarget.getAttribute("aria-expanded") === "true"
  }

  #apply(open) {
    this.triggerTarget.setAttribute("aria-expanded", String(open))
    this.panelTarget.hidden = !open
  }
}
